export default __webpack_public_path__ + "static/media/TITULO_DISCO_11.ae343912.png";